export const FETCH_ORGANIZATION_REQUEST = 'FETCH_ORGANIZATION_REQUEST';
export const FETCH_ORGANIZATION_SUCCESS = 'FETCH_ORGANIZATION_SUCCESS';
export const FETCH_ORGANIZATION_FAILURE = 'FETCH_ORGANIZATION_FAILURE';

export const FETCH_LINE_MASTER_REQUEST = 'FETCH_LINE_MASTER_REQUEST';
export const FETCH_LINE_MASTER_SUCCESS = 'FETCH_LINE_MASTER_SUCCESS';
export const FETCH_LINE_MASTER_FAILURE = 'FETCH_LINE_MASTER_FAILURE';

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const SET_USER_CREDENTIALS = 'SET_USER_CREDENTIALS';
export const LOGOUT = "LOGOUT";

// Action types for Season
export const FETCH_SEASON_REQUEST = "FETCH_SEASON_REQUEST";
export const FETCH_SEASON_SUCCESS = "FETCH_SEASON_SUCCESS";
export const FETCH_SEASON_FAILURE = "FETCH_SEASON_FAILURE";

export const FETCH_WAREHOUSE_REQUEST = "FETCH_WAREHOUSE_REQUEST";
export const FETCH_WAREHOUSE_SUCCESS = "FETCH_WAREHOUSE_SUCCESS";
export const FETCH_WAREHOUSE_FAILURE = "FETCH_WAREHOUSE_FAILURE";

export const FETCH_CLIENT_IP_REQUEST = "FETCH_CLIENT_IP_REQUEST";
export const FETCH_CLIENT_IP_SUCCESS = "FETCH_CLIENT_IP_SUCCESS";
export const FETCH_CLIENT_IP_FAILURE = "FETCH_CLIENT_IP_FAILURE";

export const FETCH_DGU_REMOTE_IP_REQUEST = "FETCH_DGU_REMOTE_IP_REQUEST";
export const FETCH_DGU_REMOTE_IP_SUCCESS = "FETCH_DGU_REMOTE_IP_SUCCESS";
export const FETCH_DGU_REMOTE_IP_FAILURE = "FETCH_DGU_REMOTE_IP_FAILURE";

export const FETCH_AD_USER_REQUEST = "FETCH_AD_USER_REQUEST";
export const FETCH_AD_USER_SUCCESS = "FETCH_AD_USER_SUCCESS";
export const FETCH_AD_USER_FAILURE = "FETCH_AD_USER_FAILURE";

